/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';
import Field from '@data-driven-forms/react-form-renderer/dist/cjs/field';

export function flattenSchema(arr: Schema | Field) {
  return arr.fields.reduce(function (flat: Field[], toFlatten: Field) {
    if (Array.isArray(toFlatten.fields)) {
      const { fields, ...fieldInfo } = toFlatten;
      return flat.concat(fieldInfo, flattenSchema(toFlatten));
    }
    return flat.concat(toFlatten);
  }, []);
}
